module.exports = __webpack_public_path__ + "15cc5dd965b1d13936ca0d0337ef7dbb.svg";